import { render, staticRenderFns } from "./t-static-field.vue?vue&type=template&id=02489b2c&scoped=true&lang=pug&"
import script from "./t-static-field.vue?vue&type=script&lang=js&"
export * from "./t-static-field.vue?vue&type=script&lang=js&"
import style0 from "./t-static-field.vue?vue&type=style&index=0&id=02489b2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02489b2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
